/**
 * 索赔左侧信息展示组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import Lang from "@components/Lang/Lang";
import ViewImage from '@components/UploadFile/UploadImage/ViewImage';
import ClaimSkuWrap from "../claimSkuWrap/SkuWrap";
import "./claim.less";

/**
 * 索赔左侧组件 - 展示客户信息、破损原因、破损产品数量、凭证及说明
 * @param {Object} model - 索赔单数据模型
 */
const ClaimLeft = ({ model = {} }) => {
    const mgPoInfoVO = model.mgPoInfoVO || {};
    return (
        <>
            {/* 客户信息 */}
            <div className="borderInfoCard">
                <div className={"flex-item font_16 black89 mb_16"}>
                    <span className={"fw_700"}>{Lang({id:"KeHuXinXi",default:"客户信息"})}</span>
                    <div className={"flex-1 ml_4 textRight"}>
                        <span className={"color-blue mr_12"}>{model.buyerCode||"-"}</span>
                        <span className={"black66"}>{model.buyerName||"-"}</span>
                    </div>
                </div>
                {/* 商品信息展示区域 */}
                <div className={"font_16"}>{Lang({id: 'DingDan', default: '订单'})} {model.poCode||"-"}</div>
                <ClaimSkuWrap item={mgPoInfoVO} />
            </div>
            
            {/* 破损原因 */}
            <div className="borderInfoCard mt_24">
                <div className={"flex-item-between font_16 black89"}>
                    <span className={"fw_700"}>{Lang({id:"PoSunYuanYin",default:"破损原因"})}</span>
                    <div>
                        <span className={"color-err"}>{model.damageCodeName||"-"}</span>
                    </div>
                </div>
            </div>
            
            {/* 破损产品数量 */}
            <div className="borderInfoCard mt_24">
                <div className={"flex-item-between font_16 black89 mb_12"}>
                    <span className={"fw_700"}>{Lang({id:"PoSunChanPinShuLiang",default:"破损产品数量"})}</span>
                </div>
                <div className={"black45 fw_700 font_16"}>
                    {Lang({id: 'KeHuGouMaiGongXiang', default: '客户购买共 {0} 箱 ｜{1} PCS',
                        params:[mgPoInfoVO.actLoadQuantity,mgPoInfoVO.quantity]})}
                </div>
                {/*历史已申请赔付了 {sku.claimQuantity} {sUnit}*/}
                {mgPoInfoVO.claimQuantity>0?<div className={"color-err"}>
                   {Lang({id: "LiShiYiShenQingPeiFuLe",default: `历史已申请赔付了 ${mgPoInfoVO.claimQuantity+" PCS"}`,params:[mgPoInfoVO.claimQuantity+" PCS"]})}
                </div>:null}
                <div className={"yellowArea mt_16"}>
                    <div className={"lineBottom"}>
                        {Lang({id: 'PoSunShangPinShuLiang', default: '破损商品数量'})}
                        <span className={'ml_4 color-err fw_700 font_16'}>{model.wornBoxQuantity||'-'}</span>
                        <span className={'ml_4'}>{Lang({id:'Xiang',default:'箱'})}</span>
                        <span className={"ml_8 fw_700"}>|</span>
                        <span className={'ml_8 color-err fw_700 font_16'}>{model.wornQuantity||"-"}</span>
                        <span className={'ml_4'}>PCS</span>
                    </div>
                    <div className={"mt_12"}>
                        {Lang({id: 'ZhengChangShangPinShuLian', default: '正常商品数量'})}
                        <span className={'ml_4 color-green2 fw_700 font_16'}>{model.normalBoxQuantity}</span>
                        <span className={'ml_4'}>{Lang({id:'Xiang',default:'箱'})}</span>
                        <span className={"ml_8 fw_700"}>|</span>
                        <span className={'ml_8 color-green2 fw_700 font_16'}>{model.normalQuantity}</span>
                        <span className={'ml_4'}>PCS</span>
                    </div>
                </div>
            </div>
            
            {/* 凭证及说明 */}
            <div className="borderInfoCard mt_24">
                <div className={"flex-item-between font_16 black89"}>
                    <span className={"fw_700"}>{Lang({id:"PingZhengJiShuoMing",default:"凭证及说明"})}</span>
                </div>
                {model.consultList&&model.consultList.length>0?<div>
                    {model.consultList.map((item,inx)=>{
                        const consultFileList = item.consultFileList&&item.consultFileList.length>0?item.consultFileList:null;
                        return item.remark||consultFileList?(<div className={"blueArea"} key={'blueArea_'+inx}>
                            {item.remark}
                            {consultFileList?<div className={"mt_4"}>
                                <ViewImage initValue={consultFileList} />
                            </div>:null}
                        </div>):null
                    })}
                </div>:null}
            </div>
        </>
    );
};

export default ClaimLeft;

